import { useEffect } from "react";
import CustomInput from "../../../Components/Atoms/CustomInput";
import CustomButton from "../../../Components/Atoms/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../../../Components/Atoms/CustomSelect";
import { Autocomplete, TextField } from "@mui/material";
import { getCronReminderEmailsListRequest } from "../../../Redux/CronSettings/CronSettingsActions";
import { getSettingsRequest } from "../../../Redux/Settings/SettingsActions";

const CreateReminder = ({ handleClose, data, formik }) => {
  const dispatch = useDispatch();

  const { getSettingsResponse } = useSelector((state) => state.settingsReducer);
  const action = data ? "edit" : "new";

  useEffect(() => {
    dispatch(getSettingsRequest());
  }, []);
  useEffect(() => {
    if (action === "edit" && data) {
      const mod_emails = data?.emails?.map((e, index) => {
        return {
          _id: index,
          email: e,
        };
      });
      const res = { ...data, emails: mod_emails };
      Object.keys(formik.values).forEach((e) => {
        formik.setFieldValue(e, res[e]);
      });
    } else {
      formik.resetForm();
    }
  }, [data]);

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <p className="mb-1">Notification Type</p>
            <CustomSelect
              type="text"
              name="notify_type"
              placeholder="SELECT NOTIFICATION TYPE"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.notify_type}
              formik={formik}
              data={[
                { name: "Email", value: "EMAIL" },
                { name: "SMS", value: "SMS" },
                { name: "Push Notification", value: "WEB_PUSH" },
                { name: "All", value: "ALL" },
              ]}
            />
          </div>
          <div className="col-md-6">
            <p className="mb-1">Mode</p>
            <CustomSelect
              type="text"
              name="mode"
              placeholder="Select Mode"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.mode}
              formik={formik}
              data={[
                { name: "Time", value: "TIME" },
                { name: "Date", value: "DATE" },
              ]}
            />
          </div>
        </div>
        <div className="row"></div>
        {formik.values.mode === "TIME" && (
          <div className="row">
            <div className="col-md-6">
              <p className="mb-1">Hour(s)</p>
              <CustomInput
                type="number"
                name="hours"
                placeholder="Enter Hour(s)"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.hours}
                formik={formik}
              />
            </div>
            <div className="col-md-6">
              <p className="mb-1">Minute(s)</p>
              <CustomInput
                type="number"
                name="minutes"
                placeholder="Enter minute(s)"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.minutes}
                formik={formik}
              />
            </div>
          </div>
        )}
        {formik.values.mode === "DATE" && (
          <div className="row">
            <div className="col-md-6">
              <p className="mb-1">Day(s)</p>
              <CustomInput
                type="number"
                name="days"
                placeholder="Enter Day(s)"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.days}
                formik={formik}
              />
            </div>
          </div>
        )}
        {["ALL", "SMS"].includes(formik.values.notify_type) && (
          <div className="row">
            <div className="col-md-6">
              <p className="mb-1">Phone Number</p>
              <CustomInput
                type="text"
                name="to_number"
                placeholder="Enter Phone Number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.to_number}
                formik={formik}
              />
            </div>
          </div>
        )}
        {["ALL", "EMAIL"].includes(formik.values.notify_type) && (
          <div className="customInputWrpr">
            <p className="mb-1">Emails</p>
            <Autocomplete
              name="emails"
              multiple
              isOptionEqualToValue={(option, value) =>
                option.email === value.email
              }
              id="emails"
              options={getSettingsResponse?.data?.emails || []}
              className="w-100"
              getOptionLabel={(option) => option?.email}
              getOptionValue={(option) => option?._id} //
              defaultValue={[[]]}
              filterSelectedOptions
              size="small"
              limitTags={2}
              onChange={(event, newValue) => {
                formik.setFieldValue("emails", newValue);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.emails || []}
              renderInput={(params) => <TextField {...params} />}
            />
            {formik.touched.emails && formik.errors?.emails && (
              <p className="errMsg">
                {formik.touched.emails && formik.errors?.emails}
              </p>
            )}
          </div>
        )}
        <div className="btnActnBar">
          <CustomButton
            btnType="secondary"
            onClick={() => handleClose()}
            label={"Cancel"}
            action={"CANCEL"}
          />
          <CustomButton label={"Save"} type="submit" action={"SAVE"} />
        </div>
      </form>
    </>
  );
};

export default CreateReminder;
